// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1igqd","content":"ManualTimeModal_content__3qXmA"};